import React, { useState } from "react";
import ReactDataTable from "../../../components/Table/ReactDataTable";
import CardLayout from "../../../components/Layout/CardLayout";
import ModalLayout from "../../../components/Layout/ModalLayout";
import CounterFormContainer from "./components/CounterFormContainer";
import useFetch from "../../../hooks/useFetch";
import request from "../../../utils/request";
import toast from "react-hot-toast";
import { Button } from "react-bootstrap";

import { FaEdit } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";

const CounterList = () => {
  const [modalOpen, setModalOpen] = useState({ modalName: "", itemId: "" });

  const { data: counterListData, setRefresh } = useFetch(() =>
    request.getAll("queue-management/counter-list/all"),
  );

  const modalCloseHandler = () => setModalOpen({ modalName: "", itemId: "" });

  const createCounterHandler = (val) =>
    request.create("queue-management/counter-list", val, () => {
      toast.success("Counter Added Successfully");
      setRefresh((prev) => !prev);
      modalCloseHandler();
    });

  const editCounterHandler = (val) =>
    request.updateOne(
      "queue-management/counter-list",
      modalOpen.itemId,
      val,
      () => {
        setRefresh((prev) => !prev);

        modalCloseHandler();
      },
    );

  const deleteCounterHandler = (val) =>
    request.delete("queue-management/counter-list", modalOpen.itemId, () => {
      setRefresh((prev) => !prev);
      modalCloseHandler();
    });

  const columns = [
    {
      name: "name",
      selector: (row) => row?.name,
      center: "true",
      wrap: true,
    },
    {
      name: "Info",
      selector: (row) => row?.info,
      center: "true",
      wrap: true,
    },
    {
      name: "On Break",
      selector: (row) => (row?.isOnBreak ? "Yes" : "No"),
      center: "true",
      wrap: true,
    },
    {
      name: "Active",
      selector: (row) => (row?.status ? "Yes" : "No"),
      center: "true",
      wrap: true,
    },
    {
      name: "Action",
      center: "true",
      wrap: true,
      cell: (row) => (
        <div>
          <Button
            onClick={() => setModalOpen({ modalName: "edit", itemId: row?.id })}
          >
            <FaEdit size={16} />
          </Button>
          <Button
            className="ms-2"
            variant="danger"
            onClick={() =>
              setModalOpen({ modalName: "delete", itemId: row?.id })
            }
          >
            <FaTrash size={16} />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <CardLayout
      title="Counter List"
      buttonTitle="Add Counter"
      addButtonHandler={() => setModalOpen({ modalName: "add", itemId: "" })}
    >
      <ReactDataTable columns={columns} data={counterListData} />

      {modalOpen.modalName === "add" && (
        <ModalLayout
          isOpen={modalOpen.modalName === "add"}
          onClose={modalCloseHandler}
          title={"Add New Counter"}
        >
          <CounterFormContainer apiHandler={createCounterHandler} />
        </ModalLayout>
      )}

      {/* edit modal  */}
      {modalOpen.modalName === "edit" && (
        <ModalLayout
          isOpen={modalOpen.modalName === "edit"}
          onClose={modalCloseHandler}
          title={"Edit Counter"}
        >
          <CounterFormContainer
            apiHandler={editCounterHandler}
            editData={counterListData?.find(
              (item) => item?.id === modalOpen.itemId,
            )}
          />
        </ModalLayout>
      )}

      {/* delete modal  */}

      {modalOpen.modalName === "delete" && (
        <DeleteModal
          isOpen={modalOpen.modalName === "delete"}
          onClose={modalCloseHandler}
          handleDelete={deleteCounterHandler}
        />
      )}
    </CardLayout>
  );
};

export default CounterList;
